export default __webpack_public_path__ + "static/media/header-white.1c81ba38.svg";